module.exports = "/_next/static/images/5f15e72940b05c313401e55728b66651-faq-table.png";